import { memo } from "react";
import Svg, { Path, type SvgProps } from "react-native-svg";

const SvgCrossOutline = (props: SvgProps) => (
  <Svg fill="none" height={24} width={24} {...props}>
    <Path
      clipRule="evenodd"
      d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18m0 2c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11"
      fill={props.color}
      fillRule="evenodd"
    />
    <Path
      clipRule="evenodd"
      d="M15.644 14.23s.316.326.707.717a.99.99 0 0 1 0 1.404 1 1 0 0 1-1.414 0l-2.908-2.908-2.908 2.908a1 1 0 0 1-1.414 0 .99.99 0 0 1 0-1.404c.39-.39.707-.717.707-.717l2.2-2.2L7.708 9.12a1 1 0 1 1 1.414-1.414l2.908 2.908 2.908-2.908a1 1 0 1 1 1.414 1.414l-2.908 2.908z"
      fill={props.color}
      fillRule="evenodd"
    />
  </Svg>
);
const Memo = memo(SvgCrossOutline);
export default Memo;
